import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPatchRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { useFlagsService } from '@atlassian/jira-flags';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { Action } from '@atlassian/react-sweet-state';
import { ZOOM_ENTITY_TYPE, ZOOM_APP_TYPE } from '../../../common/constants';
import messages from '../../../common/messages';
import { SET_ZOOM_WORKSPACE_CONNECTIONS_STATE_ERROR } from '../../constants';
import type { ContainerProps, State } from '../../types';
import type { SetConnectionStateProps } from './types';

export const setZoomWorkspaceConnectionStateForProject =
	({ connectionId, projectId, enabled }: SetConnectionStateProps): Action<State, ContainerProps> =>
	async ({ getState, setState }, { cloudId, analyticsEvent }) => {
		const { zoomWorkspaceConnections } = getState();
		const { showFlag } = useFlagsService();
		if (zoomWorkspaceConnections.isChangeInStatusProgress) {
			return;
		}
		setState({
			zoomWorkspaceConnections: {
				...zoomWorkspaceConnections,
				isChangeInStatusProgress: true,
			},
		});
		try {
			await performPatchRequest(
				`/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/chat-connection-entity-control`,
				{
					body: JSON.stringify({
						entityType: ZOOM_ENTITY_TYPE,
						entityId: projectId,
						connectionId,
						enabled,
						appType: ZOOM_APP_TYPE,
					}),
				},
			);
			fireOperationalAnalytics(
				analyticsEvent,
				'setZoomWorkspaceConnectionStateForProject succeeded',
			);
			setState({
				zoomWorkspaceConnections: {
					...zoomWorkspaceConnections,
					isZoomEnabled: enabled,
					isChangeInStatusProgress: false,
				},
			});
			showFlag({
				type: 'success',
				title: enabled
					? messages.zoomConnectionToProjectEnabledSuccessFlagTitle
					: messages.zoomConnectionToProjectDisabledSuccessFlagTitle,
				description: enabled
					? messages.zoomConnectionToProjectEnabledSuccessFlagText
					: messages.zoomConnectionToProjectDisabledSuccessFlagText,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			fireErrorAnalytics({
				meta: {
					id: 'setZoomWorkspaceConnectionStateForProject',
					packageName: 'jiraServicedeskIncidentManagementSettings',
				},
				error: e,
				sendToPrivacyUnsafeSplunk: true,
			});
			setState({
				zoomWorkspaceConnections: {
					...zoomWorkspaceConnections,
					isChangeInStatusProgress: false,
					error: {
						value: e.errorMessage,
						type: SET_ZOOM_WORKSPACE_CONNECTIONS_STATE_ERROR,
					},
				},
			});
			showFlag({
				type: 'error',
				title: enabled
					? messages.zoomConnectionToProjectEnabledErrorFlagTitle
					: messages.zoomConnectionToProjectDisabledErrorFlagTitle,
				description: enabled
					? messages.zoomConnectionToProjectEnabledErrorFlagText
					: messages.zoomConnectionToProjectDisabledErrorFlagText,
			});
		}
	};
